import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import Subheader from "material-ui/Subheader";
import Divider from "material-ui/Divider";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Big from "big.js";

import {
  CheckBox,
  CurrencyField,
  IconButton,
  Loadable,
  Page,
  StyledButton,
  TextField
} from "components/support";

import style from "./style";
import { colors } from "assets";

class OptionalForm extends Component {
  render() {
    const { className, presenter, viewModel } = this.props;
    const { title, loading, form, errors } = viewModel;

    let value = "";

    if (form.value) {
      value = Big(form.value)
        .div(100)
        .toFixed(2);
    }

    return (
      <div className={`${className} grid-container`}>
        <Page>
          <Typography type="display1" className="pb-sm">
            <IconButton
              icon="arrow_back"
              onClick={() => presenter.onGoBack()}
            />
            {title}
          </Typography>
          <Loadable loading={loading}>
            <Paper elevation={1}>
              <Subheader>Os campos marcados com * são obrigatórios.</Subheader>

              <Divider />

              <Row className="grid-container mt-sm mb-sm">
                <Col xs={12} sm={6}>
                  <TextField
                    fullWidth
                    underlineShow={false}
                    value={form.name}
                    floatingLabelFixed
                    floatingLabelText="Nome do Grupo*"
                    onChange={(_, value) => presenter.onChange("name", value)}
                    errorText={errors.name}
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <CurrencyField
                    allowNegative={false}
                    fullWidth
                    value={value || ""}
                    label="Valor dos Opcionais do Grupo"
                    unit="R$ "
                    errorText={errors.value}
                    onChange={(_, value) =>
                      presenter.onChange("value", value.replace(/\D/g, ""))
                    }
                  />
                </Col>
              </Row>

              <Row className="grid-container mt-sm mb-sm">
                <Col xs={12} sm={6}>
                  <Row className="ph-sm">
                    <CheckBox
                      style={{ marginTop: "7px", paddingBottom: "-4px" }}
                      checked={form.mandatory}
                      label="Quantidade mínima de opcionais por cliente"
                      onCheck={checked =>
                        presenter.onChangeMandatoryCheckBox(checked)
                      }
                    />
                  </Row>

                  <Row className="ph-sm">
                    <TextField
                      style={{ margin: "0px" }}
                      fullWidth
                      underlineShow={false}
                      disabled={!form.mandatory}
                      value={form.mandatory_quantity || ""}
                      placeholder="Informe a quantidade mínima de opcionais por cliente"
                      floatingLabelFixed
                      onChange={(_, value) =>
                        presenter.onChange(
                          "mandatory_quantity",
                          value.replace(/\D/g, "")
                        )
                      }
                      errorText={errors.mandatory_quantity}
                    />
                  </Row>
                </Col>

                <Col xs={12} sm={6}>
                  <Row className="ph-sm">
                    <CheckBox
                      style={{ marginTop: "7px", paddingBottom: "-4px" }}
                      checked={form.limited}
                      label="Quantidade máxima de opcionais por cliente"
                      onCheck={checked =>
                        presenter.onChangeLimitedCheckBox(checked)
                      }
                    />
                  </Row>

                  <Row className="ph-sm">
                    <TextField
                      style={{ margin: "0px" }}
                      fullWidth
                      underlineShow={false}
                      disabled={!form.limited}
                      value={form.limited_value || ""}
                      placeholder="Informe a quantidade máxima de opcionais por cliente"
                      floatingLabelFixed
                      onChange={(_, value) =>
                        presenter.onChange(
                          "limited_value",
                          value.replace(/\D/g, "")
                        )
                      }
                      errorText={errors.limited_value}
                    />
                  </Row>
                </Col>
              </Row>

              <Row className="ml-sm">
                <Col xs={12} sm={2}>
                  <Row center="xs">
                    <Col
                      xs={12}
                      className="create-sub-optionals"
                      onClick={() => presenter.handleNewOptional()}
                    >
                      <Typography type="subheading" className="pb-sm">
                        Adicione uma nova opção
                      </Typography>
                      <IconButton
                        mini
                        icon="add"
                        iconStyle={{ color: `${colors.secondary.dark}` }}
                      />
                    </Col>
                  </Row>
                  <Row center="xs" bottom="xs">
                    <Col xs={12}>
                      <Typography type="caption" className="optionals-errors">
                        {errors.optionals}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={10}>
                  <Row>
                    {form.optionals.map((optional, i) => (
                      <Col
                        key={i}
                        xs
                        lg={12}
                        style={{ display: "inline-block" }}
                        className="full-width"
                      >
                        <Row className="m-0 full-width" top="xs">
                          <Col xs={12} lg={4} className={`mt-0 mb-sm mr-sm`}>
                            <TextField
                              fullWidth
                              underlineShow={false}
                              value={optional.name}
                              floatingLabelFixed
                              focus={
                                form.optionals.length - 1 === i &&
                                form.optionals[i].name === ""
                              }
                              floatingLabelText={`Nome do Item ${i + 1}`}
                              onChange={(_, value) =>
                                presenter.onChangeOptional(value, i, "name")
                              }
                              errorText={errors.optionalNameErrors[i]}
                            />
                          </Col>

                          <Col xs={12} lg={4} className={`mt-0 mb-sm mr-sm`}>
                            <CurrencyField
                              allowNegative={false}
                              fullWidth
                              value={optional.value || value}
                              label={`Valor do Item ${i + 1}`}
                              unit="R$ "
                              onChange={(_, value) =>
                                presenter.onChangeOptional(value, i, "value")
                              }
                            />
                          </Col>

                          <Col xs={12} lg={2} className={`mt-0 mb-sm mr-sm`}>
                            <CheckBox
                              style={{ paddingTop: 30 }}
                              checked={optional.mandatory}
                              label="Obrigatório"
                              onCheck={checked =>
                                presenter.onChangeOptional(
                                  checked,
                                  i,
                                  "mandatory"
                                )
                              }
                              errorText={errors.optionalMandatoryErrors[i]}
                            />
                          </Col>

                          <Col xs={12} lg className="mr-md align-delete-button">
                            <IconButton
                              mini
                              icon="delete"
                              style={{ paddingBottom: 12, marginLeft: 20 }}
                              onClick={() => presenter.onDeleteOptional(i)}
                            />
                          </Col>
                        </Row>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>

              <div className="text-right p-sm">
                <StyledButton
                  label="Cancelar"
                  onClick={() => presenter.onGoBack()}
                  flat
                />

                <StyledButton
                  label="Salvar Grupo de Opcionais"
                  primary={true}
                  className="optional__submit"
                  onTouchTap={() => presenter.onSendForm()}
                >
                  Salvar Grupo de Opcionais
                </StyledButton>
              </div>
            </Paper>
          </Loadable>
        </Page>
      </div>
    );
  }
}

export default style(OptionalForm);



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/form/view.jsx